import { View } from '@adobe/react-spectrum';
// NOTE: This import is here to make sure that the Tags classes are included
import '@react/react-spectrum/TagList';
import React, { useContext, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Monorepo shared components
import { useRootHref } from '@exchange-frontends/custom-hooks';
import { azSort } from '@exchange-frontends/utils';

import { DetailHeading } from '../../../../../components/DetailHeading';
import { useStore } from '../../../store';
import { ConfigContext } from '../../App';

const SidebarCategories = ({ categoryIds, type, isPreview }) => {
  const { ROUTES } = useContext(ConfigContext) ?? {};
  const browseLink = useRootHref(ROUTES?.BROWSE ?? '');
  const categories = useStore((store) => store.ccCategories);
  const categoryNames = useMemo(
    () =>
      categoryIds
        ?.map((id) => categories?.find((category) => category?.key === id)?.name)
        ?.filter((name) => name) // filter null and undefined
        ?.sort(azSort),
    [categories, categoryIds]
  );

  return type?.toLowerCase() === 'cc' && categoryNames?.length > 0 ? (
    <>
      <DetailHeading level={4}>Categories</DetailHeading>
      <View marginBottom="size-400">
        <div aria-label="tags" className="spectrum-Tags">
          {categoryNames?.map((tag) => (
            <RouterLink
              key={tag}
              data-testid="category-display"
              className="spectrum-Tags-item"
              to={`${browseLink}/${type?.toLowerCase() === 'cc' ? 'cc' : 'ec'}/?tag=${encodeURIComponent(
                tag
              )}&sort=RELEVANCE`}
              style={{ textDecoration: 'none', pointerEvents: isPreview ? 'none' : undefined }}
              data-launchid="Categories"
            >
              <span className="spectrum-Tags-itemLabel" style={{ pointerEvents: 'none' }}>
                {tag}
              </span>
            </RouterLink>
          ))}
        </div>
      </View>
    </>
  ) : null;
};

export default SidebarCategories;
